"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONTextBoxPropertiesConverter = void 0;
var common_1 = require("@devexpress/utils/lib/utils/common");
var text_box_properties_1 = require("../../../floating-objects/text-box-properties");
var json_floating_enums_1 = require("../../enums/json-floating-enums");
var JSONTextBoxPropertiesConverter = (function () {
    function JSONTextBoxPropertiesConverter() {
    }
    JSONTextBoxPropertiesConverter.convertFromJSON = function (obj) {
        var result = new text_box_properties_1.TextBoxProperties();
        result.resizeShapeToFitText = !!obj[json_floating_enums_1.JSONTextBoxProperties.ResizeShapeToFitText];
        result.upright = !!obj[json_floating_enums_1.JSONTextBoxProperties.Upright];
        result.verticalAlignment = obj[json_floating_enums_1.JSONTextBoxProperties.VerticalAlignment];
        result.wrapText = !!obj[json_floating_enums_1.JSONTextBoxProperties.WrapText];
        result.leftMargin = obj[json_floating_enums_1.JSONTextBoxProperties.LeftMargin];
        result.rightMargin = obj[json_floating_enums_1.JSONTextBoxProperties.RightMargin];
        result.topMargin = obj[json_floating_enums_1.JSONTextBoxProperties.TopMargin];
        result.bottomMargin = obj[json_floating_enums_1.JSONTextBoxProperties.BottomMargin];
        return result;
    };
    JSONTextBoxPropertiesConverter.convertToJSON = function (source) {
        var result = {};
        result[json_floating_enums_1.JSONTextBoxProperties.ResizeShapeToFitText] = common_1.boolToInt(source.resizeShapeToFitText);
        result[json_floating_enums_1.JSONTextBoxProperties.Upright] = common_1.boolToInt(source.upright);
        result[json_floating_enums_1.JSONTextBoxProperties.VerticalAlignment] = source.verticalAlignment;
        result[json_floating_enums_1.JSONTextBoxProperties.WrapText] = common_1.boolToInt(source.wrapText);
        result[json_floating_enums_1.JSONTextBoxProperties.LeftMargin] = source.leftMargin;
        result[json_floating_enums_1.JSONTextBoxProperties.RightMargin] = source.rightMargin;
        result[json_floating_enums_1.JSONTextBoxProperties.TopMargin] = source.topMargin;
        result[json_floating_enums_1.JSONTextBoxProperties.BottomMargin] = source.bottomMargin;
        return result;
    };
    return JSONTextBoxPropertiesConverter;
}());
exports.JSONTextBoxPropertiesConverter = JSONTextBoxPropertiesConverter;
